export default __webpack_public_path__ + "static/media/img_declaration_slogan2.afc5e148.png";